import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogFooter,
  DialogHeader,
  DialogDescription,
} from '@cargomatic/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { updatePreArrivalShipmentStatus } from 'utils/ShipmentWebAPIUtils';

const UpdatePrenoticeShipmentStatusModal = ({
  orders,
  status,
  shipmentCount,
  onHide,
  open = false,
}) => {
  const { t } = useTranslation();
  const toStatus = status === 'final' ? 'FINAL' : 'PRE_NOTICE';
  const fromStatus = toStatus === 'FINAL' ? 'PRE_NOTICE' : 'FINAL';

  const handleOnSubmit = async () => {
    try {
      await updatePreArrivalShipmentStatus({ orders, status });
      showToast('', t('UPDATE_SUCCESS'));
    } catch (e) {
      showToast('', e.message, 'error');
    } finally {
      onHide();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onHide} className="z-50">
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>
            {t('UPDATE_PRENOTICE_STATUS_TITLE', {
              from: t(fromStatus),
              to: t(toStatus),
            })}
          </DialogTitle>
          <DialogDescription>
            {t('UPDATE_PRENOTICE_STATUS_DESCRIPTION', {
              count: shipmentCount,
              to: t(toStatus),
            })}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button className="bg-transparent text-black" onClick={onHide}>
            {t('CANCEL')}
          </Button>
          <Button type="submit" onClick={handleOnSubmit}>
            {t('CONFIRM')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpdatePrenoticeShipmentStatusModal;
